import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import TenantList from './components/TenantList';
import Login from './components/Login';
import Usuarios from './components/UserList';
import Header from './components/Header';
import Footer from './components/Footer';
import Sidebar from './components/Sidebar';
import './styles/global.css';
import { SnackbarProvider } from './context/SnackbarContext';
import api from './services/api';
import Produtos from './components/ProductList';
import TenantProducts from './components/TenantProducts';
import Signature from './components/Signature';
import Dashboard from './components/Dashboard';
import SignatureList from './components/SignatureList';
import SignatureDetails from './components/SignatureDetails';
import SignaturesDashboard from './components/SignaturesDashboard';
import DocumentsList from './components/DocumentsList';
import DocumentUpload from './components/DocumentUpload';
import DocumentDetails from './components/DocumentDetails';
import logo from './logoParallaxDev.png';

// Função para verificar autenticação
const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};


// Componente para proteger rotas
const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  return isAuthenticated() ? children : <Navigate to="/" />;
};

const Welcome: React.FC = () => (
  <div style={{ padding: 24, textAlign: 'center' }}>
    <img src={logo} alt="Logo Parallax Dev" style={{ width: '50%', height: 'auto' }} />
  </div>
);

const App: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [user, setUser] = useState<{ nome: string; perfil: string }>({ nome: '', perfil: '' });

  useEffect(() => {
    console.log('Estado atualizado do usuário:', user);
  }, [user]);

  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Função para buscar os dados do usuário logado
  const fetchUserData = async () => {
    try {
      const response = await api.get('/api/auth/me');
      console.log('Resposta completa da API:', response.data); // Verifique o que está vindo da API
      setUser({
        nome: response.data.nome || '',
        perfil: response.data.perfil || response.data.role || ''
      });
      console.log('Estado atualizado do usuário:', {
        nome: response.data.nome || '',
        perfil: response.data.perfil || response.data.role || ''
      });
    } catch (error) {
      console.error('Erro ao buscar dados do usuário:', error);
    }
  };

  useEffect(() => {
    if (isAuthenticated()) {
      fetchUserData();
    }
  }, [localStorage.getItem('token')]);

  return (
    <SnackbarProvider>
      <Router>
        {isAuthenticated() && (
          <>
            {/* Header e Sidebar visíveis apenas para usuários autenticados */}
            <Header onToggleSidebar={handleToggleSidebar} user={user} />
            <Sidebar isOpen={isSidebarOpen} onClose={handleToggleSidebar} />
          </>
        )}
        <Routes>
          {/* Rota pública para login ou tela de boas-vindas se autenticado */}
          <Route path="/" element={isAuthenticated() ? <Welcome /> : <Login />} />

          {/* Rotas privadas */}
          <Route
            path="/clients"
            element={
              <PrivateRoute>
                <TenantList />
              </PrivateRoute>
            }
          />
          <Route
            path="/usuarios"
            element={
              <PrivateRoute>
                <Usuarios />
              </PrivateRoute>
            }
          />
          <Route
            path="/produtos"
            element={
              <PrivateRoute>
                <Produtos />
              </PrivateRoute>
            }
          />
          <Route
            path="/assinaturas"
            element={
              <PrivateRoute>
                <Signature />
              </PrivateRoute>
            }
          />
          <Route
            path="/assinaturas/list"
            element={
              <PrivateRoute>
                <SignatureList />
              </PrivateRoute>
            }
          />
          <Route
            path="/assinaturas/documents"
            element={
              <PrivateRoute>
                <DocumentsList />
              </PrivateRoute>
            }
          />
          <Route
            path="/assinaturas/documents/upload"
            element={
              <PrivateRoute>
                <DocumentUpload />
              </PrivateRoute>
            }
          />
          <Route
            path="/assinaturas/documents/:docPath"
            element={
              <PrivateRoute>
                <DocumentDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/assinaturas/:id"
            element={
              <PrivateRoute>
                <SignatureDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/assinaturas/dashboard"
            element={
              <PrivateRoute>
                <SignaturesDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/assinaturas/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/clients/products"
            element={
              <PrivateRoute>
                <TenantProducts />
              </PrivateRoute>
            }
          />
        </Routes>
        {isAuthenticated() && <Footer />} {/* Footer visível apenas para usuários autenticados */}
      </Router>
    </SnackbarProvider>
  );
};

export default App;